import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { PerformanceModuleData } from './summary-combo.models';

@Injectable({
    providedIn: 'root'
})
export class SummaryComboService {

    constructor(
        private cvAPIService: CVApiService
    ) { }

    // maybe make the second two parameters optional (two declarations in moduleFactory)
    async LoadPerformanceData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean, abort?: Promise<void>): Promise<PerformanceModuleData> {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvAPIService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }
        const urlOptions = moduleKey + "?isAutoRefresh=" + !!isAutoRefresh + "&isFirstLoad=" + !!isFirstLoad;
        const url = "/api/v2/dashboards/modules/performanceModuleData/" + urlOptions;

        try {
            const response = await this.cvAPIService.get(url, renderEndpoint, abort);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data as PerformanceModuleData;
        } catch (error) {
            console.error("Failed getting performance data.");
            throw error;
        }
    }

    async tableLoadPerformanceDataForExport(moduleKey: string, format, isCXOne: boolean, moduleID: number) {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvAPIService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }

        const url = "/api/v2/dashboards/modules/performanceModuleData/" + moduleKey + "/" + moduleID + "/export?format=" +
            format + "&isCXOne=" + isCXOne;
        try {
            const response = await this.cvAPIService.get<string>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            else
                return response;
        } catch (error) {
            console.error("Failed getting performance data for export.");
            throw error;
        }
    }
}
